import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import * as s from "react";
const a = (o, t) => /* @__PURE__ */ r.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: t, ...o, children: /* @__PURE__ */ r.jsx("path", { fill: "currentColor", d: "M3.5 8.5a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5-6.5a6.5 6.5 0 1 0 0 13 6.472 6.472 0 0 0 4.036-1.404l4.188 4.188a.75.75 0 0 0 1.06-1.06l-4.187-4.189A6.5 6.5 0 0 0 8.5 2Z" }) }), l = s.forwardRef(a);
export {
  l as F
};
//# sourceMappingURL=Search20.DPh0h8Ck.js.map
